var OrderedSourceLocaleResolver_1;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable, multiInject } from "inversify";
import { raise } from "@leavy/utils";
import { LocaleSource } from "../../locale/sources/LocaleSource";
import { LocalizationOptionsStore } from "../../options/LocalizationOptions";
let OrderedSourceLocaleResolver = OrderedSourceLocaleResolver_1 = class OrderedSourceLocaleResolver {
    constructor(sources, options) {
        this.sources = sources;
        this.options = options;
    }
    static withConfig(config) {
        let ConfiguredOrderedSourceLocaleResolver = class ConfiguredOrderedSourceLocaleResolver extends OrderedSourceLocaleResolver_1 {
            constructor() {
                super(...arguments);
                this.config = config;
            }
        };
        ConfiguredOrderedSourceLocaleResolver = __decorate([
            injectable()
        ], ConfiguredOrderedSourceLocaleResolver);
        return ConfiguredOrderedSourceLocaleResolver;
    }
    async resolve() {
        const ordered = !this.config ? this.sources :
            this.config.order.map(cls => this.sources.find(s => s instanceof cls) ??
                raise(new Error("Locale utmSource should exist")));
        const proposals = (await Promise.all(ordered.map(x => x.getLocales()))).flat();
        const supported = proposals.filter(x => this.options.isSupportedLocale(x));
        if (supported.length > 0)
            return supported[0];
        const bestMatches = proposals
            .map(x => this.options.getBestSupportedLocale(x))
            .filter(x => x !== undefined);
        if (bestMatches.length > 0)
            return bestMatches[0];
        else
            return undefined;
    }
};
OrderedSourceLocaleResolver = OrderedSourceLocaleResolver_1 = __decorate([
    injectable(),
    __param(0, multiInject(LocaleSource)),
    __param(1, inject(LocalizationOptionsStore)),
    __metadata("design:paramtypes", [Array, LocalizationOptionsStore])
], OrderedSourceLocaleResolver);
export { OrderedSourceLocaleResolver };
//# sourceMappingURL=OrderedSourceLocaleResolver.js.map